module.exports = __webpack_public_path__ + "c5fc297bcc6f30587f3347715eb8a398.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/special-conditions/alergias.png
// module id = 259
// module chunks = 0